import React, { useEffect } from 'react';
import { apis, apiHolder, apiHolder as api, } from 'api';
import useGetReadStatus from '@web-mail/components/ReadMail/hooks/useGetReadStatus';
import OpenRecords from './OpenRecords';
import { Spin } from 'antd';
const nsSettingPrefix = 'notShowSpamTipsForMail-';
const mailManagerApi = apiHolder.api.requireLogicalApi('mailConfApiImpl');
const storeApi = api.api.getDataStoreApi();
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const eventApi = apiHolder.api.getEventApi();
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailPlusCustomerApi = apiHolder.api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const systemApi = api.api.getSystemApi();
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const aiAssistantApi = api.api.requireLogicalApi(apis.aiAssistant);
const OpenRecordsContent = props => {
    const { data } = props;
    const content = data;
    const { openRecordData, setOpenRecordData, readStatus, setReadStatus, debounceGetStatusOrDetail, getStatusOrDetail, getMailReadDetail } = useGetReadStatus(content);
    useEffect(() => {
        setOpenRecordData({ count: 0, records: [] });
        getMailReadDetail(data);
    }, [data]);
    let forbid = false;
    try {
        const forbidList = JSON.parse(productAuthApi.getABSwitchSync('mail_trace_forbidden_domains'));
        if (forbidList && forbidList.length) {
            const userInfo = systemApi.getCurrentUser();
            if (forbidList.find((item) => { var _a; return (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) === null || _a === void 0 ? void 0 : _a.endsWith(item); })) {
                forbid = true;
            }
        }
    }
    catch (e) {
    }
    return (React.createElement("div", { className: "sirius-scroll", style: { width: process.env.BUILD_ISEDM ? '528px' : '282px', minHeight: 142, maxHeight: 352 } }, openRecordData ? (React.createElement(OpenRecords, { content: content, openRecordData: openRecordData, forbid: forbid })) : (React.createElement("div", { style: { height: 350, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
        React.createElement(Spin, { tip: "" })))));
};
export default OpenRecordsContent;
